import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingRoutingModule } from './setting-routing.module';
import {SharedModule} from "../shared/shared.module";
import { SettingComponent } from './setting/setting.component';
import {DepartmentComponent} from "./department/department.component";
import {ReactiveFormsModule} from "@angular/forms";
import { EmployeeRolesComponent } from './employee-roles/employee-roles.component';
import { PermissionRolesComponent } from './permission-roles/permission-roles.component';
import { PermissionRoleEditComponent } from './permission-roles/permission-role-edit/permission-role-edit.component';
import { ProfileComponent } from './profile/profile.component';
import { RessourceCategoryComponent } from './ressource-category/ressource-category.component';
import { RessourceComponent } from './ressource/ressource.component';
import { HolidayGridComponent } from './holiday/holiday-grid/holiday-grid.component';
import { TenantSettingsComponent } from './tenant-settings/tenant-settings-ui/tenant-settings.component';
import { FlexTimeCorrectionGridComponent } from './flex-time-correction/flex-time-correction-grid/flex-time-correction-grid.component';
import { FiscalYearGridComponent } from './fiscal-year/fiscal-year-grid/fiscal-year-grid.component';
import { TimeSupplementsComponent } from './time-supplement/time-supplements/time-supplements.component';
import { ExpenseTypesComponent } from './expense-types/expense-types.component';



@NgModule({
  declarations: [
    SettingComponent,
    DepartmentComponent,
    EmployeeRolesComponent,
    PermissionRolesComponent,
    PermissionRoleEditComponent,
    ProfileComponent,
    RessourceCategoryComponent,
    RessourceComponent,
    HolidayGridComponent,
    TenantSettingsComponent,
    FlexTimeCorrectionGridComponent,
    FiscalYearGridComponent,
    TimeSupplementsComponent,
    ExpenseTypesComponent
  ],
    imports: [
      CommonModule,
      SettingRoutingModule,
      SharedModule,
      ReactiveFormsModule
    ]
})
export class SettingModule { }
